var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"alt",attrs:{"id":"header"}},[_c('h1',[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v(_vm._s(_vm.title))])],1),_c('nav',[_c('a',{attrs:{"href":"#menu"},on:{"click":_vm.toggleMenu}},[_vm._v("Menu")])])])}
var staticRenderFns = []

export { render, staticRenderFns }